<template>
  <div id="event-detail" v-if="detail.aggregate_id !== ''">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'Domain'|t }}:</td>
        <td>{{ detail.domain }}</td>
      </tr>
      <tr>
        <td>{{ 'Aggregate type'|t }}:</td>
        <td>{{ detail.aggregate_type }}</td>
      </tr>
      <tr>
        <td>{{ 'Aggregate ID'|t }}:</td>
        <td>{{ detail.aggregate_id }}</td>
      </tr>
      <tr>
        <td>{{ 'Aggregate version'|t }}:</td>
        <td>
          <div class="button-group no-gaps">
            <a class="disabled button" v-if="detail.aggregate_version <= 1"> << </a>
            <a class="button" @click.prevent="prev" v-if="detail.aggregate_version > 1"> << </a>
            <span class="hollow button">{{ detail.aggregate_version }} / {{ detail.aggregate_version_last }}</span>
            <a class="button" @click.prevent="next" v-if="detail.aggregate_version < detail.aggregate_version_last"> >> </a>
            <a class="disabled button" v-if="detail.aggregate_version >= detail.aggregate_version_last"> >> </a>
          </div></td>
      </tr>
      <tr>
        <td>{{ 'Event ID'|t }}:</td>
        <td>{{ detail.event_id }}</td>
      </tr>
      <tr>
        <td>{{ 'Event'|t }}:</td>
        <td>{{ detail.event_name }}</td>
      </tr>
      <tr>
        <td>{{ 'Sequence'|t }}:</td>
        <td>{{ detail.sequence }}</td>
      </tr>
      <tr>
        <td>{{ 'Date'|t }}:</td>
        <td>{{ detail.timestamp|timestamp }}</td>
      </tr>
      <tr>
        <td>{{ 'Author'|t }}:</td>
        <td>{{ detail.author_id }}</td>
      </tr>
      <tr>
        <td>{{ 'Correlation'|t }}:</td>
        <td>{{ detail.correlation_id }}</td>
      </tr>
      <tr>
        <td>{{ 'Causation'|t }}:</td>
        <td>{{ detail.causation_id }}</td>
      </tr>
      </tbody>
    </table>
    <div class="callout">
      <h3>{{ 'Aggregate state'|t }}</h3>
      <small><pre>{{ JSON.stringify(JSON.parse(detail.snapshot), null, 2) }}</pre></small>
    </div>
  </div>
</template>
<script>
  import api from '@/api';

  export default {
    name: 'Detail',
    props: {
      domain: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true,
      },
      id: {
        type: String,
        required: true
      },
      version: {
        type: Number,
        required: false,
        default: 0,
      }
    },
    data() {
      return {
        use_version: 0,
        detail: {
          domain: "",
          aggregate_type: "",
          aggregate_id: "",
          aggregate_version: 0,
          aggregate_version_last: 0,
          snapshot: "",
          event_id: "",
          event_name: "",
          sequence: 0,
          timestamp: 0,
          author_id: "",
          correlation_id: "",
          causation_id: ""
        }
      }
    },
    created() {
      this.use_version = this.version;
      this.load()
    },
    methods: {
      prev() {
        if (this.detail.aggregate_version > 1) {
          this.use_version = this.detail.aggregate_version - 1;
          this.load();
        }
      },
      next() {
        if (this.detail.aggregate_version_last > this.detail.aggregate_version) {
          this.use_version = this.detail.aggregate_version + 1;
          this.load();
        }
      },
      load() {
        api.snapshotAggregate(
          { domain: this.domain, aggregate_type: this.type, aggregate_id: this.id, aggregate_version: this.use_version },
          data => this.detail = data
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/event/Detail.vue